import slugify from 'react-slugify'

export const sortItemName = (items = [], prop) => {
  return items.slice().sort((a, b) => {
    var nameA = a[prop] && slugify(a[prop].toLowerCase(), { delimiter: '-' })
    var nameB = b[prop] && slugify(b[prop].toLowerCase(), { delimiter: '-' })
    if (nameA < nameB) return -1
    if (nameA > nameB) return 1
    return 0
  })
}



// WEBPACK FOOTER //
// ./src/Shared/SortItems/index.js